/* eslint-disable no-case-declarations */
import { find, get } from 'lodash';
import { getClientConfigData } from 'src/workspace/utils';
import {
  PATH_I18N_CONFIG_CURRENCY,
  PATH_I18N_CONFIG_LOCALE,
  PATH_I18N_CONFIG_QUANTITY,
  PATH_METRIC_DATA_TYPE,
  PATH_METRIC_TARGET_PROGRESS_PERCENTAGE,
  PATH_METRIC_TARGET_PROGRESS_TYPE,
  PATH_METRIC_TARGET_VALUE,
  PATH_METRIC_VALUE,
  PATH_PROGRESS_TYPE_SETTINGS,
} from '../../constant';
import { convertToKMBOrKLCWeb } from '../../snapshot/queries';

export const getMetricData = (metric) => {
  const dataType = get(metric, PATH_METRIC_DATA_TYPE);
  const total = get(metric, PATH_METRIC_TARGET_VALUE, 0);

  const actual = get(metric, PATH_METRIC_VALUE, 0);
  const config = getClientConfigData();
  const currency = get(config, PATH_I18N_CONFIG_CURRENCY, '');
  const currencyQuantity = get(config, PATH_I18N_CONFIG_QUANTITY, 'KLC');
  const locale = get(config, PATH_I18N_CONFIG_LOCALE, 'en-IN');
  const formattedTotal = convertToKMBOrKLCWeb(
    total,
    2,
    dataType === 'currency',
    dataType === 'percentage',
    '',
    {
      currencyQuantity,
      currency,
      locale,
    },
  );
  const formattedActual = convertToKMBOrKLCWeb(
    actual,
    2,
    dataType === 'currency',
    dataType === 'percentage',
    '',
    {
      currencyQuantity,
      currency,
      locale,
    },
  );
  return {
    actual: formattedActual,
    total: formattedTotal,
  };
};

export const getMetricProgressPercent = (metric) => {
  const progressPercentage = get(
    metric,
    PATH_METRIC_TARGET_PROGRESS_PERCENTAGE,
    null,
  );
  return progressPercentage;
};

export const getMetricProgressColor = (metric) => {
  const progressType = get(metric, PATH_METRIC_TARGET_PROGRESS_TYPE, null);

  const progressTypeSettings = get(metric, PATH_PROGRESS_TYPE_SETTINGS, []);
  const progressColor =
    find(progressTypeSettings, { goal_progress_type: progressType })?.color ||
    'var(--text-default)';
  return progressColor;
};
